module.exports = __webpack_public_path__ + "static/img/ZX-logo.6d141223.png";